import * as d3 from 'd3';
import { getClassByCountOfDigits } from '../helpers/getClassByCountOfDigits';
import { chartStore } from '../../crashStore/chartStore';

class ChartAnimate {
  WIDTH = 690;

  HEIGHT = 450;

  margin = 20;

  padding = 12;

  yAxisWidth = 30;

  xAxisHeight = 18;

  currentRoundHeight = 40 + this.padding * 2;

  constructor(store) {
    this.store = store;
    this.xGroup = null;
    this.yGroup = null;
    this.bars = null;
  }

  setXGroup(prop) {
    this.xGroup = prop;
  }

  setYGroup(prop) {
    this.yGroup = prop;
  }

  setBars(prop) {
    this.bars = prop;
  }

  addDotes() {
    return <span>&#8226;</span>;
  }

  calcRoundTime(launchTime) {
    return launchTime ? (Date.now() - launchTime) / 1000 : 0;
  }

  calcOdd(launchTime) {
    const exponent = this.calcRoundTime(launchTime) / 8;
    return Math.max(1, 2 ** exponent.toFixed(2));
  }

  handleAxisAnimations() {
    if (document.hidden) {
      return;
    }
    const { launchTime } = this.store;
    const odd = Number(this.calcOdd(launchTime));
    const y = d3.scaleLinear();

    const yAxis = d3.axisRight(y).ticks(5);
    const x = d3.scaleLinear();

    const xAxis = d3.axisBottom(x).ticks(6);
    const time = this.calcRoundTime(launchTime);

    y.domain([1, odd <= 1.8 ? 1.8 : odd]).range([
      0,
      -this.HEIGHT + this.currentRoundHeight + this.xAxisHeight + this.margin + 50,
    ]);

    x.domain([1, time <= 6 ? 6 : time]).range([0, this.WIDTH - this.yAxisWidth - this.padding * 4]);

    if (this.xGroup) {
      this.xGroup
        .attr(
          'transform',
          `translate(${this.yAxisWidth + this.padding * 3}, ${
            this.HEIGHT - this.xAxisHeight - this.margin
          })`
        )
        .attr('font-size', 13)
        .attr('letter-spacing', 0.88)
        .attr('font-family', `'Lato', sans-serif`)
        .transition()
        .ease(d3.easeLinear)
        .duration(500)
        .call(
          xAxis
            .tickSize(0)
            .tickFormat((d) => (d === 0 ? '' : `${d}s ${this.addDotes()?.props?.children}`))
        );
    }

    if (this.yGroup) {
      this.yGroup
        .attr(
          'transform',
          `translate(${this.padding}, ${this.HEIGHT - this.margin - this.xAxisHeight - 26})`
        )
        .attr('font-size', 13)
        .attr('letter-spacing', 0.88)
        .attr('font-family', `'Lato', sans-serif`)
        .transition()
        .ease(d3.easeLinear)
        .duration(100)
        .call(
          yAxis.tickSize(0).tickFormat((d) => {
            return d === 0 ? '' : `${d.toFixed(1)}x ${this.addDotes()?.props?.children}`;
          })
        );
    }

    const axisSelection = d3.select('.odd-axis');
    axisSelection.selectAll('.tick').classed(getClassByCountOfDigits(odd), true);

    if (this.bars) {
      this.bars
        .attr(
          'transform',
          `translate(${this.yAxisWidth + this.padding * 3}, ${
            this.HEIGHT - this.xAxisHeight - this.margin * 2
          })`
        )
        .transition()
        .ease(d3.easeLinear)
        .duration(500)
        .call(xAxis.tickSize(-(this.HEIGHT - 150), 0, 0).tickFormat(''));
    }
  }
}

export const chartAnimate = new ChartAnimate(chartStore);
